import { forwardRef } from 'react'
import { generatePath } from 'react-router-dom'
import { useWorkspace } from '@opallabs/hooks'
import { Link } from '@opallabs/lapidary'
import { OpalRoutes } from '@opallabs/routing'
import * as styles from './styles'

export const CreateBoardOption = forwardRef<HTMLAnchorElement>(
  (_props, ref) => {
    const { slug: workspaceSlug } = useWorkspace()

    return (
      <Link
        ref={ref}
        href={generatePath(OpalRoutes.Boards, { workspaceSlug })}
        target="_blank"
        css={styles.linkStyles}
        // Prevent click from re-triggering the dropdown's item click handler
        onClick={(e) => e.stopPropagation()}
      >
        Create New Board
      </Link>
    )
  }
)

CreateBoardOption.displayName = 'CreateBoardOption'
